import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DwUserStorage } from './user-storage';


@Injectable()
export class DwUserService {

  /**
  * 取用即時更改內容(存入名稱 = 取出鍵名)
  */
  public userInfo = {};
  public overAllParam: any = {};
  public myEnt : number;

  constructor(protected userStorage: DwUserStorage) {
    // reload 時, 可以取出已經儲存的資料.
    const userInfo = this.userStorage.get('DwFxed020UserInfo');
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }
    const overAllParam = this.userStorage.get('DwSysInfo');
    if (overAllParam) {
      this.overAllParam = JSON.parse(overAllParam);
    }
    const myEnt = this.userStorage.get('DwFxed020EntInfo');
    if (myEnt) {
      this.myEnt = myEnt;
    }
  }

  /**
   * 儲存內容
   * string 須用 {id: key, value: data}傳入
   */
  public setUser(userInfo: any): void {
    if (!userInfo.id) {
      return;
    }
    if (userInfo.id.indexOf('overAll') !== -1) {
      this.overAllParam[userInfo.id] = userInfo.value;
      this.userStorage.set('DwSysInfo', JSON.stringify(this.overAllParam));
    } else {
      // console.log('setUser---');
      this.userInfo[userInfo.id] = userInfo.value;
      this.userStorage.set('DwFxed020UserInfo', JSON.stringify(this.userInfo));
    }
  }
  public setmyEnt(ent: number): void {
    if (!ent) {
      return;
    }
      this.myEnt = ent;
      this.userStorage.set('DwFxed020EntInfo', this.myEnt);
  }

  /**
   * 獲取儲存內容(對應id下資料)
   */
  public getUser(key: string): any {
    if (!key) {
      return;
    }

    return this.userInfo[key];
  }

  /**
   * getmyEnt
   */
  public getmyEnt() {
    return this.myEnt;
  }

  /**
   * 清除所有儲存內容(只能清除屬於user的資料).
   */
  public clearUser(): void {
    this.userStorage.remove('DwFxed020UserInfo');
    this.userInfo = {};
    this.userStorage.remove('DwSysInfo');
    this.overAllParam = {};
  }


  /**
   * 取得使用者資訊.
   * return 返回Observable
   */
  public read(userId: string, ent: number): Observable<object> {
    const info = {
      success: true,
      description: '', // 取值失敗時, 顯示.
      userInfo: null // 取得的回傳值.
    };

    const userInfo = {
      userId: userId,
      userName: userId
    };

    info.userInfo = userInfo;

    this.setUserInfo(userInfo);
    this.setmyEnt(ent);

    return Observable.create((observer) => {
      observer.next(info);
      observer.complete(); // 在 create 裡, 需要 complete.
    });
  }

  /**
   * 批次儲存使用者資訊.
   *
   * param {*} userInfo
   */
  public setUserInfo(userInfo: any): void {
    for (const field of Object.keys(userInfo)) {
      // console.log('setUserInfo---');
      this.setUser({ id: field, value: userInfo[field] });
    }

    let userId = {id: 'userId', value: userInfo.c_user};
    this.setUser(userId);
  }
  public setEntInfo(ent: number): void {
    this.setmyEnt(ent);
  }

}

